/* istanbul ignore file */
export const MAP_FIELD_POINT_CONSTANTS = {
    MapFieldPointPrefix: 'mapFieldPoint',
    MapFieldPointSubRowToolTip: 'Sub-rows cannot have their own point categories or coordinates. These fields apply only to parent rows.'
};
